import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import debounce from '../../utils/debounce'
import { gettime2 } from '../../utils/time'
import { gethome, getsystemlis, eventperson, getkeywords } from '../../utils/api'
import { useParams } from "react-router";
// import { Toast } from '@nutui/nutui-react';
import { Toast } from 'zarm';
import { InfiniteScroll } from 'antd-mobile'
import { divide } from 'lodash';


const option = {
    display: 'flex',
    backgroundColor: '#303136',
    borderRadius: '10px',
    paddingLeft: '10px',
    margin: 5,
    // flex: 1,
    // width:'30%',
    justifyContent: 'space-between'
}

const condition = {
    height: '40px',
    lineHeight: '40px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#BABBBE',
    fontSize: '13px',
}

const y = {
    height: '18px', width: '18px', borderRadius: '9px', backgroundColor: '#fff', margin: '2px'
}
const w = { height: '22px', backgroundColor: '#B1B5C1', width: '44px', borderRadius: '11px' }

const y2 = {
    height: '18px', width: '18px', borderRadius: '9px', backgroundColor: '#fff', margin: '2px'
}
const w2 = { height: '22px', backgroundColor: '#26ab50', width: '44px', borderRadius: '11px', display: 'flex', flexDirection: 'row', justifyContent: 'end' }

const Filters: React.FC = () => {

    const { t } = useTranslation()

    const [search, setsearch] = useSearchParams()
    const [ids, setids] = useState(search.get("id"));
    const [eventkeywords, seteventkeywords] = useState([]);


    const [keywordsdata, setkeywordsdata] = useState(search.get("keywords")) as any;
    const [keywordarr, setkeywordarr] = useState([]);








    const [tabSelected, getSelected] = useState(true);
    const [types, getypes] = useState(false);
    const [alltypes, getalltypes] = useState(0);
    let [country, getcountry] = useState(localStorage.getItem('country'))
    const [Alltype, getalltype] = useState('All types');
    const [fields, getfields] = useState('All fields');
    const [Sort, getSort] = useState('Upcoming');
    const [type, settype] = useState([{
        dictValue: '',
        dictLabel: ''
    }]);
    const [eventType, seteventType] = useState('');

    const [userId, setuserId] = useState('');

    let upcomingRef = useRef([]) as any;
    const [upcoming, getupcoming] = useState([]) as any;

    useEffect(() => {
        upcomingRef.current = upcoming

    }, [upcoming])

    // const params = useParams()

    let data2: any = []
    data2 = localStorage.getItem('getMyContacts')
    data2 = JSON.parse(data2)




    const data3 = ['Upcoming', 'Popular']




    const [show, setshow] = useState(false)


    const goBackPage = () => {
        window.history.back()
    }

    const getAlltype = () => {
        document.body.style.overflow = 'hidden'
        getypes(true)
        getalltypes(1)
    }


    const getAlltype2 = () => {
        document.body.style.overflow = 'hidden'
        // if(!tabSelected){
        // let Frienddata = data2 ? data2 : []

        // if (Frienddata.length > 0) {
        getypes(true)
        getalltypes(2)
        // } else {
        //     Toast.show(t('Youhavennotaddedafriendyet'));
        // }
        // }else{
        //     Toast.show(t('Friendfilteringhasbeenturnedoff'));
        // }

    }

    const getAlltype3 = () => {
        document.body.style.overflow = 'hidden'
        getypes(true)
        getalltypes(3)
    }


    const systemlis = async () => {
        await getsystemlis('sys_event_status').then((res) => {
            settype(res.data)
        }
        );
    }


    let [num, setNum] = useState(0)
    let Numref = useRef(num);

    useEffect(() => {
        Numref.current = num
    }, [num])

    const [val, setval] = useState('')


    let [keywords, setkeywords] = useState('')

    let keywordRref = useRef(keywords);
    useEffect(() => {
        keywordRref.current = keywords
    }, [keywords])

    const inputval = debounce(() => {

        upcomingRef.current = []
        getupcoming(upcomingRef.current)
        Numref.current = 0

        keywordRref.current = val
        setkeywords(keywordRref.current)
        getDate(val)


    }, 1000, setval)

    const geif = () => {
        const data: any = []
        let data2: any = []
        data2 = localStorage.getItem('getMyContacts')
        data2 = JSON.parse(data2)
        let Frienddata = data2 ? data2 : []
        Frienddata.forEach((item: any) => {
            data.push(item.userId)
        })

        return data
    }

    const color16 = () => {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        var color = 'rgb(' + r + ',' + g + ', ' + b + ')';
        return color
    }


    const getDate = async (keywords: any) => {
        setHasMore(true)
        let state = ''
        if (Sort == 'Upcoming') {
            state = '0'
        } else if (Sort == 'Popular') {
            state = '1'
        }
        const eventCountry = localStorage.getItem('country')
        Numref.current = Numref.current + 1
        setNum(Numref.current)
        await gethome({
            // eventCountry,
            eventName:keywordRref.current,
            keywords:userId,
            // pageNum: Numref.current,
            current: Numref.current,
            pageSize: 10,
            state,
            eventType: eventType,
            pid: ids,
            // linUserId: userId
        }).then((res) => {





            let data = geif()
            settotal(res.total)
            if (res.rows.length > 0) {
                res.rows.forEach((item: any, index: any) => {
                    item.time = gettime2(item.eventStartTime, item.eventEndTime)
                    item.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })

                    item.people = 0
                    eventperson({
                        linUserIds: data,
                        eventId: item.eventId
                    }).then((re) => {


                        // if (re.data) {
                        if (re.data) {
                            item.people = re.data.friends
                        }

                        if (index == res.rows.length - 1) {
                            let tmp = upcomingRef.current
                            tmp.push(...res.rows)
                            tmp.forEach((item: any) => {
                                item.eventBanner = item.eventBanner.replace('http:', 'https:')
                            })
                            getupcoming([...tmp])

                            setHasMore(true)

                            if (total > upcomingRef.current) {
                                setHasMore(true)
                            } else {
                                setHasMore(false)
                            }
                        }
                    }
                        // }
                    );
                });
            } else {
                setHasMore(false)
                return false
            }

        }
        );
        document.body.style.overflow = 'auto'
    }



 

    const [hasMore, setHasMore] = useState(true)
    async function loadMore() {

    }
    let [total, settotal] = useState(0)
    let totalref = useRef(total);
    useEffect(() => {
        totalref.current = total
    }, [total])



    const scrollEvent2 = debounces(() => {
        let html = document.documentElement || document.body
        if (html.scrollTop >= html.scrollHeight - html.clientHeight - 100) {
            if (totalref.current > upcomingRef.current.length) {
                getDate(val)

            } else {
                setHasMore(false)
            }
        }
    }, 500)

    const getDate2 = async (keywords: any, dictValue: any, userIds: any, Sorts: any) => {
        setHasMore(true)
        upcomingRef.current = []
        getupcoming(upcomingRef.current)
        let state = ''
        if (Sorts == 'Upcoming') {
            state = '0'
        } else if (Sorts == 'Popular') {
            state = '1'
        }
        const eventCountry = localStorage.getItem('country')
        Numref.current = 1
        setNum(Numref.current)
        await gethome({
            // eventCountry,
            eventName:keywords,
            keywords:userIds,
            // pageNum: Numref.current,
            current: Numref.current,
            pageSize: 10,
            state,
            eventType: dictValue,
            pid: ids,
            // linUserId: userIds
        }).then((res) => {


            let data = geif()
            settotal(res.total)
            if (res.rows.length > 0) {
                res.rows.forEach((item: any, index: any) => {
                    item.time = gettime2(item.eventStartTime, item.eventEndTime)
                    item.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })

                    item.people = 0
                    eventperson({
                        linUserIds: data,
                        eventId: item.eventId
                    }).then((re) => {


                        // if (re.data) {
                        if (re.data) {
                            item.people = re.data.friends
                        }

                        if (index == res.rows.length - 1) {
                            let tmp = upcomingRef.current
                            tmp.push(...res.rows)
                            tmp.forEach((item: any) => {
                                item.eventBanner = item.eventBanner.replace('http:', 'https:')
                            })
                            getupcoming([...tmp])

                            setHasMore(true)

                            if (res.total > upcomingRef.current.length) {
                                setHasMore(true)
                            } else {
                                setHasMore(false)
                            }
                        }
                    }
                        // }
                    );
                });
            } else {
                setHasMore(false)
                return false
            }
         
        }
        );
        document.body.style.overflow = 'auto'
    }

    // const getDate3 = async (keywords: any, dictValue: any, userIds: any, Sorts: any) => {
    //     keywordRref.current = ''
    //     setkeywords(keywordRref.current)
    //     setHasMore(true)
    //     upcomingRef.current = []
    //     getupcoming(upcomingRef.current)
    //     let state = ''
    //     if (Sorts == 'Upcoming') {
    //         state = '0'
    //     } else if (Sorts == 'Popular') {
    //         state = '1'
    //     }
    //     const eventCountry = localStorage.getItem('country')
    //     Numref.current = 1
    //     setNum(Numref.current)
    //     await gethome({
    //         // eventCountry,
    //         keywords: userIds,
    //         // pageNum: Numref.current,
    //         current: Numref.current,
    //         pageSize: 10,
    //         state,
    //         eventType: dictValue,
    //         pid: ids,
    //         // linUserId: userIds
    //     }).then((res) => {
    //         let data = geif()
    //         settotal(res.total)
    //         if (res.rows.length > 0) {
    //             res.rows.forEach((item: any, index: any) => {
    //                 item.time = gettime2(item.eventStartTime, item.eventEndTime)
    //                 item.sdmUsers.forEach((i: any) => {
    //                     i.c = color16()
    //                     i.imgUrl = i.imgUrl + ''
    //                 })

    //                 item.people = 0
    //                 eventperson({
    //                     linUserIds: data,
    //                     eventId: item.eventId
    //                 }).then((re) => {


    //                     // if (re.data) {
    //                     if (re.data) {
    //                         item.people = re.data.friends
    //                     }

    //                     if (index == res.rows.length - 1) {
    //                         let tmp = upcomingRef.current
    //                         tmp.push(...res.rows)
    //                         getupcoming([...tmp])

    //                         setHasMore(true)

    //                         if (res.total > upcomingRef.current.length) {
    //                             setHasMore(true)
    //                         } else {
    //                             setHasMore(false)
    //                         }
    //                     }
    //                 }
    //                     // }
    //                 );
    //             });
    //         } else {
    //             setHasMore(false)
    //             return false
    //         }
    //     }
    //     );
    // }
    function debounces(func: any, wait: any) {
        var timeout: any;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };

    }


    const getkeyword = async () => {
        await getkeywords({
            eventId: ids,
        }).then((res) => {


            // let arr = res.data[0].split('##')
            let arr: any = []

            res.data.forEach((item: any) => {
                let arr2 = item.split('##')
                arr2.forEach((item2: any) => {
                    if (item2 != '') {
                        arr.push(item2)
                    }

                })

            })

            // arr3.forEach((item: any,index:number) => {
            //     let item2 = item.toUpperCase()
            //     if(arr3.indexOf(item2) == -1){
            //         arr.push(item)
            //     }
            // })




            // arr = [...new Set(arr)];
            arr =Array.from(new Set(arr.map((item:any)=> item.toLowerCase())));
            console.log(arr)
            setkeywordarr(arr)

        }
        );
    }

    useEffect(() => {

        document.body.style.overflow = 'auto'
        window.scrollTo(0, 0);
        systemlis()
        getDate(val)
        getkeyword()
        // let arr = JSON.parse(keywordsdata)
        // setkeywordarr(arr)

        document.addEventListener('scroll', scrollEvent2)
        // document.addEventListener('scroll', scrollEvent)
        return () => {
            document.removeEventListener('scroll', scrollEvent2);
        };
    }, []);

    return <div style={{ backgroundColor: '#1B1D22', position: 'relative' }}>

        {
            types && <div style={{ backgroundColor: '#000', width: '100%', height: '100%', zIndex: 100, opacity: 0.3, position: 'absolute', cursor: 'pointer' }}
                onClick={() => {getypes(false);document.body.style.overflow = 'auto'}}>
            </div>
        }
        {
            types && <div style={{
                position: 'fixed', bottom: 0, borderTopRightRadius: '20px', borderTopLeftRadius: '20px', backgroundColor: '#37383D', zIndex: 999,
                color: '#fff', width: '100%', display: 'flex',
                justifyContent: 'center', alignItems: 'center', flexDirection: 'column', flexWrap: 'wrap', cursor: 'pointer'
            }} onClick={() => {getypes(false);document.body.style.overflow = 'auto'}}>
                <div style={{ backgroundColor: '#999999', width: '30px', height: '4px', marginBottom: '40px' }}></div>
                {alltypes == 1 && <div style={{ width: '100%' }}>
                    <div style={{
                        textAlign: 'left', height: '35px', marginBottom: '16px',
                        marginLeft: '30px', marginRight: '30px', borderBottom: '1px solid #9797971F'
                    }}
                        onClick={() => { getalltype('All types'); seteventType(''); getDate2(val, null, userId, Sort) }}>
                        {t('Alltypes')}
                    </div>
                    {type.map((item, index) => <div key={index} style={{
                        textAlign: 'left', height: '35px', marginBottom: '16px',
                        marginLeft: '30px', marginRight: '30px', borderBottom: '1px solid #9797971F', cursor: 'pointer'
                    }}
                        // onClick={() => { getDate2(item.dictLabel,item.dictValue)} }>
                        onClick={() => { getalltype(item.dictLabel); seteventType(item.dictValue); getDate2(val, item.dictValue, userId, Sort) }}>
                        {item.dictLabel}
                    </div>)}
                </div>
                }

                {alltypes == 2 && <div style={{ width: '100%' }}>

                    <div style={{
                        textAlign: 'left', height: '35px', marginBottom: '16px',
                        marginLeft: '30px', marginRight: '30px', borderBottom: '1px solid #9797971F', cursor: 'pointer'
                    }}
                        onClick={() => { getfields('All fields'); setuserId(''); getDate2(val, eventType, '', Sort) }}>
                        {t('Allfields')}
                    </div>

                    {keywordarr.map((item: any, index: any) => <div>
                        {
                            item != '' && <div key={index} style={{
                                textAlign: 'left', height: '35px', marginBottom: '16px',
                                marginLeft: '30px', marginRight: '30px', borderBottom: '1px solid #9797971F', cursor: 'pointer'
                            }}
                                onClick={() => { getfields(item); setuserId(item); getDate2(val, eventType, item, Sort) }}>
                                {item}
                            </div>
                        }

                    </div>)}
                </div>
                }

                {alltypes == 3 && <div style={{ width: '100%' }}>
                    {data3.map((item, index) => <div key={index} style={{
                        textAlign: 'left', height: '35px', marginBottom: '16px',
                        marginLeft: '30px', marginRight: '30px', borderBottom: '1px solid #9797971F', cursor: 'pointer'
                    }}
                        onClick={() => { getSort(item); getDate2(val, eventType, userId, item) }}>
                        {item}
                    </div>)}
                </div>
                }

            </div>
        }

        <div style={{ display: 'flex', padding: '20px' }}>
            <div style={{ position: 'relative' }}>
                <img src={require("../../static/img/Search.png")} style={{ width: '22px', height: '22px', alignSelf: 'center', position: 'absolute', left: '20px', top: '10px' }} ></img>
                <input type="text" value={val} onChange={(e) => inputval(e)}
                    style={{
                        width: '70vw', height: '40px', backgroundColor: '#000000', borderRadius: 5, display: 'flex',
                        color: '#fff', lineHeight: '40px', marginLeft: 10, fontSize: '14px', border: 'none', paddingLeft: '40px'
                    }} placeholder='search' />
            </div>
            <div style={{ color: '#BABBBE', marginLeft: '20px', lineHeight: '40px', width: '45px', textAlign: 'center', cursor: 'pointer' }} onClick={() => goBackPage()}>{t('Cancel')}
            </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginLeft: '20px', marginRight: '20px', cursor: 'pointer' }}>
            <div style={option} onClick={() => getAlltype()}>
                <div style={{
                    height: '40px',
                    lineHeight: '40px',
                    overflow: 'hidden',
                    width: '50px',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color: '#BABBBE',
                    fontSize: '13px',
                }} >{Alltype}</div>
                <img src={require("../../static/img/Back.png")} style={{ width: '22px', height: '22px', alignSelf: 'center', marginLeft: '5px', marginRight: '5px' }} ></img>
            </div>
            <div style={option} onClick={() => getAlltype2()}>
                <div style={{
                    height: '40px',
                    lineHeight: '40px',
                    width: '50px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color: '#BABBBE',
                    fontSize: '13px',
                }} >{fields}</div>
                <img src={require("../../static/img/Back.png")} style={{ width: '22px', height: '22px', alignSelf: 'center', marginLeft: '5px', marginRight: '5px' }} ></img>
            </div>
            <div style={option} onClick={() => getAlltype3()}>
                <div style={{
                    height: '40px',
                    lineHeight: '40px',
                    width: '50px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color: '#BABBBE',
                    fontSize: '13px',
                }}>{Sort}</div>
                <img src={require("../../static/img/Back.png")} style={{
                    width: '22px',
                    height: '22px',
                    alignSelf: 'center',
                    marginLeft: '5px', marginRight: '5px'
                }} ></img>
            </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '20px' }}>
            <div style={{ color: '#BABBBE', fontWeight: 500, fontSize: '14px' }}>
                {t('friendswillgos')}
            </div>
            <div style={tabSelected ? w : w2} onClick={() => getSelected(!tabSelected)}>
                <div style={tabSelected ? y : y2}></div>
            </div>
        </div>
        {upcoming.length > 0 && <div style={{ backgroundColor: '#1B1D22', paddingTop: '10px' }}>

            {
                tabSelected == true ? <div>
                    {
                        upcoming.map((item: any, index: any) => <div>

                            {
                                total >= index + 1 && <Link to={`/details?eventId=${item.eventId}&country=${country}`
                                    // `/eventdetails?eventId=${item.eventId}`
                                }
                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                    key={index}
                                >
                                    <div style={{
                                        backgroundColor: '#202225',
                                        alignItems: 'center',
                                        // position: 'relative',
                                        borderRadius: '20px',
                                        padding: '20px',
                                        paddingTop: 0
                                    }}>
                                        <div style={{
                                            width: '100%',
                                            borderRadius: '20px',
                                            backgroundColor: '#35363B',
                                            position: 'relative',
                                        }}>
                                            <div style={{ height: '100px', overflow: 'hidden', }}>
                                                <img src={item.eventBanner} style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    borderTopRightRadius: '20px',
                                                    borderTopLeftRadius: '20px',
                                                }} alt="" />
                                            </div>
                                            {item.sideNumber != 0 &&

                                                <div style={{
                                                    display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                                    borderRadius: '30px', justifyContent: 'center', position: 'absolute', right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px'
                                                    , alignItems: 'center'
                                                }}>
                                                    <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                                        width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                                    }} alt="" />
                                                    {item.sideNumber} {t('Sideevents')}
                                                </div>
                                            }

                                            <div style={{ margin: 10 }}>
                                                {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                                <div style={{ fontSize: '24px', fontWeight: 700, padding: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis',whiteSpace: 'nowrap', width: '95%' }}>{item.eventName}</div>
                                                <div style={{
                                                    color: '#8E929D',
                                                    fontSize: '14px',
                                                    alignItems: 'center',
                                                    paddingTop: '5px'
                                                }}>
                                                    <img src={require("../../static/img/Date.png")} style={{
                                                        marginLeft: '5px',
                                                        marginRight: '5px',
                                                        width: '14px',
                                                        height: '14px'
                                                    }}></img> {item.time}
                                                    {/* {t('6November-7November')} */}
                                                </div>
                                                <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                >
                                                    <div style={{
                                                        color: '#8E929D',
                                                        fontSize: '14px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        paddingTop: '5px'
                                                    }}>
                                                        <img src={require("../../static/img/tdesign_location.png")} style={{
                                                            marginLeft: '5px',
                                                            marginRight: '5px',
                                                            width: '14px',
                                                            height: '14px',
                                                            // paddingTop: '5px'
                                                        }}></img>  <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.eventLocation}</span>
                                                        {/* {t('NewYork,UnitedStates')} */}
                                                    </div>
                                                </Link>
                                            </div>
                                            <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                                        {item.sdmUsers.map((item2: any, index: number) => <div>
                                                            {
                                                                index < 4 && <div>
                                                                    {
                                                                        item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                                                            width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px', border: '2px solid #2F3039',
                                                                            position: 'absolute', left: index * 14,
                                                                        }} alt="" /> :
                                                                            <div key={index} style={{
                                                                                width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px',
                                                                                position: 'absolute', left: index * 14, textAlign: 'center',
                                                                                backgroundColor: item2.c, color: '#fff', fontSize: '16px', border: '2px solid #2F3039'
                                                                            }} >{item2.sdmUserName != null ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                                    }

                                                                </div>
                                                            }
                                                            {
                                                                index == 4 && <img src={require("../../static/img/Group.png")}
                                                                    key={index} style={{ width: '24px', height: '24px', position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px' }}></img>
                                                            }
                                                        </div>
                                                        )}
                                                    </div>
                                                    {/* {item.people > 0 &&
                                                    <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px' }}>
                                                        {item.people}{t('friendswillgo')}
                                                    </div>
                                                } */}
                                                </div>
                                                {item.people > 0 &&
                                                    <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                                        <span style={{ marginRight: '5px' }}> {item.people}</span>{t('friendswillgo')}
                                                    </div>
                                                }
                                                <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                                    <img src={require("../../static/img/Vector2.png")} style={{
                                                        width: '12.5px',
                                                        height: '20px', marginRight: '5px'
                                                    }} ></img>
                                                    {item.eventNumber}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            }
                        </div>

                        )
                    }</div> : <div>

                    {
                        upcoming.map((item: any, index: any) => <div>

                            {
                                total >= index + 1 && item.people != 0 && <Link to={`/details?eventId=${item.eventId}&country=${country}`
                                    // `/eventdetails?eventId=${item.eventId}`
                                }
                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                    key={index}
                                >
                                    <div style={{
                                        backgroundColor: '#202225',
                                        alignItems: 'center',
                                        // position: 'relative',
                                        borderRadius: '20px',
                                        padding: '20px',
                                        paddingTop: 0
                                    }}>
                                        <div style={{
                                            width: '100%',
                                            borderRadius: '20px',
                                            backgroundColor: '#35363B',
                                            position: 'relative',
                                        }}>
                                            <div style={{ height: '100px', overflow: 'hidden', }}>
                                                <img src={item.eventBanner} style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    borderTopRightRadius: '20px',
                                                    borderTopLeftRadius: '20px',
                                                }} alt="" />
                                            </div>
                                            {item.sideNumber != 0 &&

                                                <div style={{
                                                    display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                                    borderRadius: '30px', justifyContent: 'center', position: 'absolute', right: '8px', top: '8px',
                                                    paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                                }}>
                                                    <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                                        width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                                    }} alt="" />
                                                    {item.sideNumber} {t('Sideevents')}
                                                </div>
                                            }


                                            <div style={{ margin: 10 }}>
                                                {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                                <div style={{ fontSize: '24px', fontWeight: 700, padding: '5px', marginBottom: '5px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '95%' }}>{item.eventName}</div>
                                                <div style={{
                                                    color: '#8E929D',
                                                    fontSize: '14px',
                                                    alignItems: 'center',
                                                    paddingTop: '5px'
                                                }}>
                                                    <img src={require("../../static/img/Date.png")} style={{
                                                        marginLeft: '5px',
                                                        marginRight: '5px',
                                                        width: '14px',
                                                        height: '14px'
                                                    }}></img> {item.time}
                                                    {/* {t('6November-7November')} */}
                                                </div>
                                                <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                >
                                                    <div style={{
                                                        color: '#8E929D',
                                                        fontSize: '14px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        paddingTop: '5px'
                                                    }}>
                                                        <img src={require("../../static/img/tdesign_location.png")} style={{
                                                            marginLeft: '5px',
                                                            marginRight: '5px',
                                                            width: '14px',
                                                            height: '14px',
                                                            // paddingTop: '5px'
                                                        }}></img>  <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.eventLocation}</span>
                                                        {/* {t('NewYork,UnitedStates')} */}
                                                    </div>
                                                </Link>
                                            </div>
                                            <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                                        {item.sdmUsers.map((item2: any, index: number) => <div>
                                                            {
                                                                index < 4 && <div>
                                                                    {
                                                                        item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{ width: '24px', height: '24px', alignSelf: 'center', border: '2px solid #2F3039', borderRadius: '12px', position: 'absolute', left: index * 14, }} alt="" /> :
                                                                            <div key={index} style={{
                                                                                width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px', position: 'absolute', left: index * 14, textAlign: 'center',
                                                                                backgroundColor: item2.c, color: '#fff', fontSize: '16px', border: '2px solid #2F3039'
                                                                            }} >{item2.sdmUserName != null ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                                    }

                                                                </div>
                                                            }
                                                            {
                                                                index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{ width: '24px', height: '24px', position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px' }}></img>
                                                            }
                                                        </div>
                                                        )}
                                                    </div>
                                                    {/* {item.people > 0 &&
                                                                    <div style={{fontSize:'12px',color:'#BABBBE',height:'24px',lineHeight:'24px'}}>
                                                                        {item.people}{t('friendswillgo')}
                                                                    </div>
                                                                } */}
                                                </div>
                                                {item.people > 0 &&
                                                    <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                                        <span style={{ marginRight: '5px' }}> {item.people}</span>{t('friendswillgo')}
                                                    </div>
                                                }
                                                <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                                    <img src={require("../../static/img/Vector2.png")} style={{
                                                        width: '12.5px',
                                                        height: '20px', marginRight: '5px'
                                                    }} ></img>
                                                    {item.eventNumber}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            }
                        </div>

                        )
                    }</div>
            }

        </div>
        }
        <div style={{ backgroundColor: '#202225' }}>
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>



    </div >
};





export default Filters;